"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var theme_1 = require("../../theme");
var Tooltip_1 = require("../Tooltip");
var getColorFromVariant = function (color) {
    return {
        error: theme_1.colors.error,
        neutral: theme_1.colors.black,
        primary: theme_1.colors.primary,
        purple: theme_1.colors.purple,
        secondary: theme_1.colors.secondary,
        success: theme_1.colors.success,
        warning: theme_1.colors.warning,
    }[color];
};
var getAdjustedSections = function (filteredSections) {
    var adjustedSections = filteredSections.slice();
    var nextSectionIndex = 1;
    // ensure first percent is > 3 (take away from following sections)
    while (adjustedSections[0].percent <= 3) {
        var nextPercent = adjustedSections[nextSectionIndex].percent;
        if (nextPercent > 1) {
            adjustedSections[nextSectionIndex].percent -= 1;
            adjustedSections[0].percent += 1;
        }
        nextSectionIndex += 1;
        if (nextSectionIndex === adjustedSections.length) {
            nextSectionIndex = 1;
        }
    }
    // ensure last percent is > 6 (take away from previous sections)
    var previousSectionIndex = adjustedSections.length - 2;
    while (adjustedSections[adjustedSections.length - 1].percent <= 6) {
        var previousPercent = adjustedSections[previousSectionIndex].percent;
        if (previousPercent > 1) {
            adjustedSections[previousSectionIndex].percent -= 1;
            adjustedSections[adjustedSections.length - 1].percent += 1;
        }
        previousSectionIndex -= 1;
        if (previousSectionIndex === -1) {
            previousSectionIndex = adjustedSections.length - 2;
        }
    }
    return adjustedSections;
};
var uid = function () {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
};
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar(props) {
        var _this = _super.call(this, props) || this;
        _this.tooltipXOffset = -79;
        _this.tooltipYOffset = -50;
        _this.state = {
            tooltipPosition: {
                x: 0,
                y: 0,
            },
            tooltipShowing: false,
            tooltipText: '',
        };
        _this.tooltipYOffset = props.tooltipYOffset || _this.tooltipYOffset;
        _this.tooltipXOffset = props.tooltipXOffset || _this.tooltipXOffset;
        return _this;
    }
    ProgressBar.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, className = _b.className, emptyColor = _b.emptyColor, _c = _b.multi, multi = _c === void 0 ? false : _c, percent = _b.percent, prefixCls = _b.prefixCls, _d = _b.sections, sections = _d === void 0 ? [] : _d, _e = _b.showLegend, showLegend = _e === void 0 ? false : _e, _f = _b.showMissingInLegend, showMissingInLegend = _f === void 0 ? true : _f, style = _b.style, tooltipStyles = _b.tooltipStyles, tooltipText = _b.tooltipText, _g = _b.tooltipVariant, tooltipVariant = _g === void 0 ? 'downSmall' : _g, variant = _b.variant, width = _b.width, _h = _b.withTooltips, withTooltips = _h === void 0 ? false : _h;
        var center = width / 2;
        var right = 100 - width / 2;
        var pathString = "M " + center + ", " + center + " L " + right + ", " + center;
        var ttStyles = tooltipStyles
            ? tooltipStyles
            : {
                left: this.state.tooltipPosition.x,
                position: 'fixed',
                textAlign: 'center',
                top: this.state.tooltipPosition.y,
            };
        var correctedPercent = percent;
        if (!multi) {
            correctedPercent = percent || percent === 0 ? percent : 100;
            if (correctedPercent > 100) {
                correctedPercent = 100;
            }
            var pathStyle = {
                strokeDasharray: '100px, 100px',
                strokeDashoffset: 100 - correctedPercent + "px",
                transition: 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s linear',
            };
            var viewBoxString = "0 0 100 " + width;
            return (React.createElement(React.Fragment, null,
                withTooltips && this.state.tooltipShowing && (React.createElement(Tooltip_1.Tooltip, { style: ttStyles, variant: tooltipVariant }, this.state.tooltipText)),
                React.createElement("svg", { className: prefixCls + "-line " + className, onMouseEnter: function (event) {
                        _this.setTooltipShowing(true);
                        _this.setTooltipText(tooltipText || percent + "%");
                        _this.repositionTooltip({ x: event.clientX, y: event.clientY });
                    }, onMouseLeave: function () {
                        _this.setTooltipShowing(false);
                    }, onMouseMove: function (event) {
                        _this.repositionTooltip({ x: event.clientX, y: event.clientY });
                    }, preserveAspectRatio: "none", style: style, viewBox: viewBoxString },
                    React.createElement("path", { className: prefixCls + "-line-trail", d: pathString, fillOpacity: "0", stroke: emptyColor || theme_1.colors.black05, strokeLinecap: "round", strokeWidth: width }),
                    React.createElement("path", { className: prefixCls + "-line-path", d: pathString, fillOpacity: "0", stroke: getColorFromVariant(variant), strokeLinecap: "round", strokeWidth: width, style: pathStyle }))));
        }
        else {
            var filteredSections_1 = sections.filter(function (section) { return section.percent > 0; });
            var adjustedSections = getAdjustedSections(filteredSections_1);
            var viewBoxString = "0 0 100 " + width;
            return (React.createElement("div", null,
                this.state.tooltipShowing && (React.createElement(Tooltip_1.Tooltip, { style: ttStyles, variant: tooltipVariant }, this.state.tooltipText)),
                React.createElement("svg", { className: prefixCls + "-line " + className, onMouseLeave: function (_) { return _this.onProgressBarLeave(); }, preserveAspectRatio: "none", style: style, viewBox: viewBoxString },
                    adjustedSections.map(function (s, idx) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        var offset = 0;
                        if (idx > 0) {
                            for (var i = 1; i <= idx; i++) {
                                offset += filteredSections_1[idx - i].percent;
                            }
                        }
                        var strokeLineCap = idx === 0 ? 'round' : 'square';
                        var capOffset = idx === filteredSections_1.length - 1 ||
                            filteredSections_1.length === 1
                            ? width
                            : 0;
                        var endOffset = filteredSections_1.length === 1 ? 2 : offset;
                        var pathString = "M " + (center + offset) + ", " + center + " L " + (s.percent + endOffset - capOffset) + ", " + center;
                        var patternId = uid() + "-progressBarFill-" + idx;
                        return (React.createElement(React.Fragment, null,
                            React.createElement("defs", null,
                                React.createElement("pattern", { height: (_a = s.stroke) === null || _a === void 0 ? void 0 : _a.patternHeight, id: patternId, patternTransform: "rotate(" + ((_b = s.stroke) === null || _b === void 0 ? void 0 : _b.patternDegreeRotation) + ")", patternUnits: "userSpaceOnUse", width: (_c = s.stroke) === null || _c === void 0 ? void 0 : _c.patternWidth },
                                    React.createElement("rect", { fill: (_d = s.stroke) === null || _d === void 0 ? void 0 : _d.backgroundColor, height: "100%", width: "100%", x: "0", y: "0" }),
                                    React.createElement("line", { stroke: (_e = s.stroke) === null || _e === void 0 ? void 0 : _e.strokeColor, "stroke-width": (_f = s.stroke) === null || _f === void 0 ? void 0 : _f.strokeLineWidth, x1: "0", x2: "0", y: "0", y2: (_g = s.stroke) === null || _g === void 0 ? void 0 : _g.patternHeight }))),
                            React.createElement("g", { fill: "none", stroke: "black" },
                                React.createElement("path", { d: pathString, fillOpacity: "0", key: "progressbar-section-" + s.label + "-" + idx, onMouseEnter: function (event) {
                                        return _this.onProgressBarSectionEnter({ event: event, section: s });
                                    }, onMouseMove: function (event) {
                                        return _this.onProgressBarSectionMove({ event: event, section: s });
                                    }, stroke: s.stroke ? "url(#" + patternId + ")" : s.color, strokeLinecap: strokeLineCap, strokeWidth: width }))));
                    }),
                    React.createElement("circle", { cx: 100 - width / 2, cy: center, fill: filteredSections_1[filteredSections_1.length - 1].stroke
                            ? (_a = filteredSections_1[filteredSections_1.length - 1].stroke) === null || _a === void 0 ? void 0 : _a.strokeColor
                            : filteredSections_1[filteredSections_1.length - 1].color, r: width / 2 })),
                showLegend && (React.createElement(Legend, { shouldWrapLegendItems: !!this.props.shouldWrapLegendItems }, (showMissingInLegend ? sections : filteredSections_1).map(function (s, idx) { return (React.createElement(LegendItem, { key: "progressbar-section-legend-" + s.label + "-" + idx },
                    React.createElement(LegendCircle, { color: s.color, diameter: s.diameter ? s.diameter : '1.33rem' }),
                    React.createElement(LegendText, null, s.label))); })))));
        }
    };
    ProgressBar.prototype.tooltipSectionTextGetter = function (section) {
        if (typeof section.tooltipLabelGetter === 'function') {
            return section.tooltipLabelGetter({ section: section });
        }
        if (typeof this.props.tooltipLabelGetter === 'function') {
            return this.props.tooltipLabelGetter({ section: section });
        }
        return section.label;
    };
    ProgressBar.prototype.onProgressBarLeave = function () {
        this.setTooltipShowing(false);
    };
    ProgressBar.prototype.onProgressBarSectionMove = function (_a) {
        var event = _a.event;
        this.repositionTooltip({ x: event.clientX, y: event.clientY });
        this.setTooltipShowing(true);
    };
    ProgressBar.prototype.onProgressBarSectionEnter = function (_a) {
        var section = _a.section;
        this.setTooltipText(section);
    };
    ProgressBar.prototype.setTooltipText = function (option) {
        this.setState({
            tooltipText: typeof option === 'string'
                ? option
                : this.tooltipSectionTextGetter(option),
        });
    };
    ProgressBar.prototype.setTooltipShowing = function (shouldShow) {
        if (this.state.tooltipShowing === shouldShow) {
            return;
        }
        this.setState({
            tooltipShowing: shouldShow,
        });
    };
    ProgressBar.prototype.repositionTooltip = function (_a) {
        var x = _a.x, y = _a.y;
        this.setState({
            tooltipPosition: {
                x: x + this.tooltipXOffset,
                y: y + this.tooltipYOffset,
            },
        });
    };
    return ProgressBar;
}(React.Component));
exports.ProgressBar = ProgressBar;
var Legend = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  ",
    "\n"])), function (props) {
    if (!props.shouldWrapLegendItems) {
        return '';
    }
    return "\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    ";
});
var LegendItem = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 2.667rem;\n  margin-top: 1.33rem;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 2.667rem;\n  margin-top: 1.33rem;\n"])));
var LegendCircle = styled_1.default('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  margin-right: 0.667rem;\n  background: ", ";\n  height: ", ";\n  width: ", ";\n  min-width: 0.33rem;\n  border-radius: 50%;\n"], ["\n  display: inline-block;\n  margin-right: 0.667rem;\n  background: ", ";\n  height: ", ";\n  width: ", ";\n  min-width: 0.33rem;\n  border-radius: 50%;\n"])), function (props) { return props.color; }, function (props) { return props.diameter; }, function (props) { return props.diameter; });
var LegendText = styled_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 1.167rem;\n  font-weight: bold;\n"], ["\n  font-size: 1.167rem;\n  font-weight: bold;\n"])));
exports.default = ProgressBar;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map